import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PaymentStatus } from '@app/shared/enums/common.enums';
import { PaymentConfirmationData } from '@app/shared/models/common.model';
import {
  PPUBypassSupervisorModel,
  PPUPaymentStatusModel,
  PPUPickupPaymentModel,
  PPUSharePaymentDetailModel,
} from '@app/shared/models/deliver-customer.model';
import { DeliverCustomerService } from '@app/shared/services/deliver-customer.service';
import { PPUAlertService } from '@app/shared/services/ppu-alert.service';
import { RequestPaymentService } from '@app/shared/services/request-payment.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-request-payment',
  templateUrl: './request-payment.component.html',
  standalone: false,
})
export class RequestPaymentComponent {
  isLoadingConfirmation: boolean = false;
  isPaymentConfirmed: boolean = false;
  supervisorBypassResult: PPUBypassSupervisorModel | undefined;
  paymentLink: string = '';
  isLoadingPaymentLink: boolean = false;
  intervalId: any;

  constructor(
    private dialogRef: MatDialogRef<RequestPaymentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PPUPickupPaymentModel,
    private ppuAlertService: PPUAlertService,
    private requestPaymentService: RequestPaymentService,
    private deliverCustomerService: DeliverCustomerService,
    private translateService: TranslateService
  ) {
    this.dialogRef.disableClose = true;
    this.dialogRef.updateSize('600px', 'auto');
  }

  ngOnInit() {
    this.requestPaymentService.paymentConfirmation.subscribe(
      (result: { orderIds: number[]; isPaymentCollected: boolean }) => {
        this.isPaymentConfirmed = this.data.orderIds.every(x => result.orderIds.includes(x)) && result.isPaymentCollected;
        this.isLoadingConfirmation = false;
        if (this.isPaymentConfirmed) {
          setTimeout(() => {
            this.closePayment();
          }, 2000);
        }
      }
    );
    this.checkPaymentStatus();
    if (!this.isPaymentConfirmed) {
      this.getPaymentQrCode();

      //Pooling payment confirmation
      //Runs after 30sec
      //Send orderId to the Subject that is subscribed in the pickup-confirmation
      setTimeout(() => {
        this.isLoadingConfirmation = true;
        this.requestPaymentService.paymentStatusSubscription(this.data.orderIds);
      }, 30000);
    }
  }

  checkPaymentStatus() {
    if (this.data.orderIds) {
      const orderIds = this.data.orderIds;
      this.deliverCustomerService.getPaymentStatuses(orderIds).subscribe({
        next: (results: PPUPaymentStatusModel[]) => {
          this.isPaymentConfirmed = !!results.length && results.every((x) => x.paymentStatusId == PaymentStatus.Successful);
          if (this.isPaymentConfirmed) {
            this.ppuAlertService.successEvent(
              this.translateService.instant('App.RequestPayment.Messages.PaymentSuccess')
            );
            setTimeout(() => {
              this.closePayment();
            }, 2000);
          }
        },
        error: (error) => {
          this.ppuAlertService.errorEvent(error[0]);
        },
      });
    }
  }

  getPaymentQrCode() {
    this.isLoadingPaymentLink = true;
    this.deliverCustomerService.createPaymentLink(this.data.orderIds).subscribe({
      next: (result: PPUSharePaymentDetailModel) => {
        if (result.paymentNeeded) {
          this.paymentLink = result.paymentLink;
        } else {
          this.isPaymentConfirmed = true;
        }
        this.isLoadingPaymentLink = false;
        this.isLoadingConfirmation = true;
      },
      error: (error) => {
        this.ppuAlertService.errorEvent(error[0]);
        this.isLoadingPaymentLink = false;
      },
    });
  }

  refreshPayment() {
    this.isLoadingConfirmation = true;
    this.requestPaymentService.paymentStatusSubscription(this.data.orderIds);
  }

  closePayment() {
    const paymentConfirmationData: PaymentConfirmationData = {
      supervisorBypassedModel: this.supervisorBypassResult,
      isPaymentConfirmed: this.isPaymentConfirmed,
    };
    this.dialogRef.close(paymentConfirmationData);
  }

  bypassPayment() {
    this.requestPaymentService.bypassPayment(this.data).subscribe((result: PPUBypassSupervisorModel) => {
      if (result) {
        this.supervisorBypassResult = result;
        this.closePayment();
      }
    });
  }
}
